var ssSessionId = '';
if(ssGetURLParameter('utm_source') != null){
	ssSessionId = ssGetURLParameter('utm_source');
}
var gclid= '';
if(ssGetURLParameter('gclid') != null){
	gclid= ssGetURLParameter('gclid');
}
if (ssSessionId.toLowerCase() == 'optimise'){
	ssSetCookie(ssSessionId);
} else if (ssSessionId.toLowerCase() != 'optimise' && ssSessionId.toLowerCase() !='' || gclid!=''){
	if(checkCookie("optimise")){
	  eraseCookie("optimise");
	}
}
function readCookie(name){
  // console.log('reading from ', name);
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++){
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name){
	document.cookie = name + "=" + name + ";expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function checkCookie(name){
	return readCookie(name) != null;
}
function ssGetURLParameter(name){
	// console.log('getting from ', name);
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null
}
function ssSetCookie(cValue){
	// console.log('setting cookie ', cValue);
	document.cookie = cValue + "=" + cValue + ";expires= " + ssCalculateExpireDate(30) +"; path=/";
}
function ssCalculateExpireDate(days){
	var d = new Date();
	d.setTime(d.getTime() + (days*24*60*60*1000));
	d.toUTCString();
	return d;
}

/* Sample JavaScript file added with ScriptTag resource. 
This sample file is meant to teach best practices.
Your app will load jQuery if it's not defined. 
Your app will load jQuery if jQuery is defined but is too old, e.g. < 1.7. 
Your app does not change the definition of $ or jQuery outside the app. 
Example: if a Shopify theme uses jQuery 1.4.2, both of these statements run in the console will still return '1.4.2'
once the app is installed, even if the app uses jQuery 1.9.1:
jQuery.fn.jquery => "1.4.2" 
$.fn.jquery -> "1.4.2"
*/

/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within 
arenâ€™t available to the outside world. */
(function(){
  
/* Load Script function we may need to load jQuery from the Google's CDN */
/* That code is world-reknown. */
/* One source: http://snipplr.com/view/18756/loadscript/ */

var loadScript = function(url, callback){

	var script = document.createElement("script");
	script.type = "text/javascript";

	// If the browser is Internet Explorer.
	if (script.readyState){ 
		script.onreadystatechange = function(){
			if (script.readyState == "loaded" || script.readyState == "complete")
{				script.onreadystatechange = null;
				callback();
			}
		};
	// For any other browser.
	} else {
		script.onload = function(){
			callback();
		};
	}

	script.src = url;
	document.getElementsByTagName("head")[0].appendChild(script);
};

/* This is my app's JavaScript */
var myAppJavaScript = function($){
	// $ in this scope references the jQuery object we'll use.
	// Don't use jQuery, or jQuery191, use the dollar sign.

	$(document).ready(function(){
      var ssSessionId = readCookie('optimise');
      // console.log('reading session id', ssSessionId);
      $.post('/cart/update.js', { attributes: {ssSessionId: ssSessionId}});
      // console.log('after cart update', ssSessionId);

      //Oldman Product Page Cart Message
      if($("#product-message").length){
        $(".product-form__buttons button").on("click", function(){
          var message = $("#product-message").val();
          console.log('Save Message: ', message);
          $.ajax({
              url: '/cart/update.js',
              type: 'POST',
              dataType: 'json',
              data: { note: message},
              success: function(result) { 
                  console.log('works');
                  console.log(result);
              },
              error: function(jqxhr, status, exception) {
                  console.log(exception);
              }
          });
          localStorage.productMessage = message;
        });
      }
      if($("#Cart-note").length){
        console.log('Has cart note field');
      	var message = localStorage.productMessage;
        console.log('Has product message');
        if(message){
          $.ajax({
              url: '/cart/update.js',
              type: 'POST',
              dataType: 'json',
              data: { note: message},
              success: function(result) { 
                  console.log('works');
                  console.log(result);
              },
              error: function(jqxhr, status, exception) {
                  console.log(exception);
              }
          });
          $("#Cart-note").val(message);
          console.log('Change to product message');
          localStorage.productMessage = "";
       	  console.log('Delete product message');
        }
      }
      //End Oldman Product Page Cart Message
	});


};

/* If jQuery has not yet been loaded or if it has but it's too old for our needs,
we will load jQuery from the Google CDN, and when it's fully loaded, we will run
our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery;
    /*append jQuery theme stylesheet */
    jQuery191('head').append('<link rel="stylesheet" type="text/css" href="//ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/themes/base/jquery-ui.css">');
    /*load jQueryUI and execute own code on callback */
    jQuery191.getScript('//ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js',function(){jQuery191.noConflict(true);myAppJavaScript(jQuery191);});

  });
} else {
    /*append jQuery theme stylesheet */
    jQuery('head').append('<link rel="stylesheet" type="text/css" href="//ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/themes/base/jquery-ui.css">');
    /*load jQueryUI and execute own code on callback */
    jQuery.getScript('//ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js',function(){myAppJavaScript(jQuery);});
}
	
})();